var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36531 4.92982L8.90615 5.89892C9.39424 6.77349 9.1983 7.92078 8.42958 8.68951C8.42958 8.68951 8.42958 8.68951 8.42957 8.68951C8.42946 8.68962 7.49723 9.62207 9.18775 11.3126C10.8776 13.0024 11.81 12.0716 11.8108 12.0708C11.8108 12.0707 11.8108 12.0707 11.8109 12.0707C12.5796 11.302 13.7268 11.1061 14.6014 11.5942L15.5705 12.135C16.8911 12.872 17.0471 14.724 15.8863 15.8848C15.1888 16.5823 14.3343 17.1251 13.3897 17.1609C11.7996 17.2212 9.09922 16.8187 6.3904 14.1099C3.68159 11.4011 3.27916 8.70069 3.33944 7.11058C3.37525 6.16601 3.91799 5.31154 4.61549 4.61403C5.77628 3.45324 7.6283 3.60921 8.36531 4.92982Z",
    fill: "#5A5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneRounded);
export default __webpack_public_path__ + "static/media/phoneRounded.fb5a54a4816be29e4f929b77f0a30db0.svg";
export { ForwardRef as ReactComponent };